import { object, string, array, mixed } from "yup";

const statusEnum = ["Applying", "Applied", "Interviewing", "Negotiating", "Accepted", "Rejected"] as const;

export const userJobSchema = object({
  jobTitle: string().required("Job title is required"),
  jobDescription: string().required("Job description is required").min(80, "Job description must be at least 80 characters"),
  companyName: string(),
  location: string(),
  jobPostingUrl: string().url("Must be a valid URL"),
  linkedResumeIds: array().of(string()),
  status: mixed().oneOf(statusEnum),
});
